module.exports = __webpack_public_path__ + "img/BRCA4_Endothelial.2daa85c6.png";